import axiosInstance from '@/api/axiosInstance';

const getCurrentUserAPI = async () => {
    let url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/user/me`;
    return await axiosInstance.get(url);
};

const signUpUser = async () => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/user/signup`;
    return await axiosInstance.post(url);
};

const getUsersAPI = async (params) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/user` + params;
    return await axiosInstance.get(url);
};

const getUserRolesAPI = async (id) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/auth/user/${id}/roles`;
    return await axiosInstance.get(url);
};

const updateUserRolesAPI = async (id, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/auth/user/${id}/roles`;
    return await axiosInstance.put(url, body);
};

const uploadUser = async (body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/user/role-mapping`;
    return await axiosInstance.post(url, body, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const downloadUserTempalte = async () => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/user/user-template`;
    return await axiosInstance.get(url, { responseType: 'blob' });
};

const downloadUserReport = async () => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/user/user-report`;
    return await axiosInstance.get(url, { responseType: 'blob' });
};

const updateUserNameAPI = async (id, name) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/user/name`;
    return await axiosInstance.put(url, { userName: name });
};

const updateUserEmailAPI = async (id, email) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/user/email`;
    return await axiosInstance.put(url, { userEmail: email });
};

const createSystemUserAPI = async (body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/user/system-user`;
    return await axiosInstance.post(url, body);
};

export default {
    getCurrentUserAPI,
    signUpUser,
    getUsersAPI,
    getUserRolesAPI,
    updateUserRolesAPI,
    uploadUser,
    downloadUserTempalte,
    downloadUserReport,
    updateUserNameAPI,
    updateUserEmailAPI,
    createSystemUserAPI,
};
